import "./ContainerRight.scss";

const ContainerRight = (props) => {
  return (
    <div
      className="container--right"
    >
      {props.children}
    </div>
  );
};

export default ContainerRight;
